import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
export function RouteReferrerBackLink({
  referrer
}) {
  var _referrer$getLinkText, _referrer$getLinkText2;
  const trackMarketplaceEvent = useTrackMarketplaceEvent(true);
  const handleClick = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'referrer back link clicked'
    }));
  };
  const linkText = (_referrer$getLinkText = (_referrer$getLinkText2 = referrer.getLinkText) === null || _referrer$getLinkText2 === void 0 ? void 0 : _referrer$getLinkText2.call(referrer)) !== null && _referrer$getLinkText !== void 0 ? _referrer$getLinkText : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplaceStorefront.referrerLinkText.default"
  });
  return /*#__PURE__*/_jsx(BackButton, {
    children: referrer.referrerType === 'internal' ? /*#__PURE__*/_jsx(RouterLink, {
      to: referrer.location,
      "data-test-id": "storefront-referrer-back-link",
      onClick: handleClick,
      children: linkText
    }) : /*#__PURE__*/_jsx(Link, {
      href: referrer.url,
      "data-test-id": "storefront-referrer-back-link",
      onClick: handleClick,
      children: linkText
    })
  });
}